import useSegment from "~/hooks/use-segment";
import AuthAPI from "~/services/auth";

const useUserStore = defineStore("user", {
  state: () => ({
    user: null as null | IModelUser,
    devices: [] as IModelDevice[],
    clubs: {} as Record<IModelFollowedSubCategoryItem["id"], IModelFollowedSubCategoryItem>,
    selected: {} as Record<string, boolean>,
    token: null as null | string, // TODO: Handling the users who are currently logged in. Will be removed in the future.
    userTokenData: null as null | IModelUserTokenData,
    creditCard: null as null | IModelCreditCard,
    hasPPVTickets: false,
    hasSubscriptions: false,
    ppvTickets: [] as IModelCommerce[],
    pendingAccessTokenRefresh: null as null | Promise<void>,
  }),

  // TODO: Manage data storing
  // Move everything from being stored into local storage to session storage
  // except token & user.
  persist: {
    key: "ott-data",
    paths: ["user", "token", "userTokenData", "clubs"],
  },

  getters: {
    isAuthenticated: state => Boolean(state.userTokenData?.token && state.user),

    followedMainCategoryIds: (state) => {
      return Object.values(state.clubs).reduce(
        (mainCategoryIds, subCategory) => {
          subCategory.categoryIds.forEach((mainCategoryId) => {
            if (!mainCategoryIds.includes(mainCategoryId))
              mainCategoryIds.push(mainCategoryId);
          });

          return mainCategoryIds;
        },
        [] as string[],
      );
    },
  },

  actions: {
    logout(revokeToken = true): void {
      const segment = useSegment();

      if (revokeToken)
        this.userTokenData?.token && AuthAPI.logout(this.userTokenData.token);

      this.token = null;
      this.userTokenData = null;
      this.user = null;
      this.creditCard = null;
      this.clubs = {};
      this.selected = {};
      this.devices = [];
      this.hasPPVTickets = false;
      this.hasSubscriptions = false;
      this.ppvTickets = [];

      segment.reset();
    },
    refreshAccessToken(): Promise<void> {
      return AuthAPI.refreshAccessToken();
    },
  },
});

export default useUserStore;

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
